import _2005 from "./2005";
import _2006 from "./2006";
import _2007 from "./2007";
import _2008 from "./2008";
import _2009 from "./2009";
import _2010 from "./2010";
import _2011 from "./2011";
import _2012 from "./2012";
import _2013 from "./2013";
import _2014 from "./2014";
import _2015 from "./2015";
import _2016 from "./2016";
import _2017 from "./2017";
import _2018 from "./2018";
import _2019 from "./2019";
import _2020 from "./2020";
import _2021 from "./2021";
import _2022 from "./2022";
import _2023 from "./2023";
import _2024 from "./2024";
import _2025 from "./2025";

export default [
  _2005,
  _2006,
  _2007,
  _2008,
  _2009,
  _2010,
  _2011,
  _2012,
  _2013,
  _2014,
  _2015,
  _2016,
  _2017,
  _2018,
  _2019,
  _2020,
  _2021,
  _2022,
  _2023,
  _2024,
  _2025,
];
